import { Text, TextProps } from '@chakra-ui/react'

import { CHART_TITLE_VARIANT_STYLES } from './chart.constants'

export type ChartTitleVariant = 'default' | 'snapshot'

export type ChartTitleProps = TextProps & {
  children?: React.ReactNode
  variant?: ChartTitleVariant
}

export const ChartTitle = ({
  children,
  variant = 'default',
  ...props
}: ChartTitleProps) => (
  <Text
    as="h3"
    fontSize="16px"
    {...CHART_TITLE_VARIANT_STYLES[variant]}
    {...props}
  >
    {children}
  </Text>
)
